import { gql } from '@apollo/client';
const COMPONENT_SIZES = gql `
  fragment ComponentSizesFragment on ComponentNode {
    sizes {
      edges {
        node {
          id
          modelSpecificationSize {
            id
            sizeName {
              id
              name
            }
          }
          productVariantSize
          productVariantAssignments {
            id
            modelSpecificationColor {
              id
              name
            }
            productVariantColor
            productVariantSize
            productVariantSnapshot {
              id
              color
              size
              productVariant {
                id
                product {
                  id
                  name
                  componentSize {
                    id
                    name
                  }
                }
                color {
                  id
                  name
                  chain
                  tape
                  slider
                }
                size {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default COMPONENT_SIZES;
